<template>
  <div class="table-responsive modal-overflow">
    <el-table :data="savedQueriesNamesList"
              highlight-current-row
              row-key="id"
              border
              style="width: 100%">
      <el-table-column
        v-if="data.type === 'Job'"
        label="Saved Job Queries"
        width="420"
        min-width="100">
        <template v-slot="props">
          {{ props.row }}
        </template>
      </el-table-column>
      <el-table-column
        v-else-if="data.type === 'Task'"
        label="Saved Task Queries"
        width="420"
        min-width="100">
        <template v-slot="props">
          {{ props.row }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="Actions">
        <template v-slot="props">
          <a @click.prevent="confirmDelete(props.row)" href="#"><img src="static/img/icon-delete.png" title="Delete Saved Search"/></a>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import {sync} from 'vuex-pathify'
  import {NOT_FOUND, OK} from 'http-status-codes'
  import {notifySuccess, notifyError, userMergePutPayload} from 'src/utilities/utils'
  import {ptracGet, ptracPutEntity} from 'src/utilities/ptracApi'
  import {mapGetters} from 'vuex'

  export default {
    props: ['data'],
    data() {
      return {
        querySelected: '',
        savedQueriesNamesList: []
      }
    },
    computed: {
      user: sync('security@user'),
      ...mapGetters({
        userId: 'security/userId'
      })
    },
    methods: {
      updateSavedQueriesNamesList() {
        this.savedQueriesNamesList = Object.keys(this.user[`saved${this.data.type}Queries`]).sort()
      },
      async deleteSavedQuery() {
        // Delete query from frontend store
        this.$store.commit(`security/deleteFromSaved${this.data.type}Queries`, this.querySelected)

        // retrieve from user record from the DB
        const userResponse = await ptracGet(`users/${this.userId}`)

        if (NOT_FOUND === userResponse.status) {
          notifyError(this, `User with ID ${this.userId} was not found. Unable to save task search.`)
          return
        }

        // Replace user record in the DB
        if (OK === userResponse.status) {
          const user = userResponse.data
          user[`saved${this.data.type}Queries`] = this.user[`saved${this.data.type}Queries`]
          const payload = userMergePutPayload(user)
          const response = await this.$store.dispatch('save2', payload)

          if (OK === response.status) {
            notifySuccess(this, `${this.data.type} query deleted successfully`)
            // Update list of queries, both here and in parent component
            this.updateSavedQueriesNamesList()
            this.$eventHub.$emit('savedQueriesNamesList', this.savedQueriesNamesList)
            return
          }
        }

        notifyError(this, `Failed to delete ${this.data.type} search`)
      },
      confirmDelete(queryName) {
        this.querySelected = queryName
        const message= 'Are you sure you want to delete <strong>' + queryName + '</strong>?'
        const payload = {message, delete: this.deleteSavedQuery, showButton: true}
        this.$eventHub.$emit('show-modal-2', 'Confirm Delete', payload, '600px')
      }
    },
    mounted() {
      this.updateSavedQueriesNamesList()
    }
  }
</script>
